import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiNpm,
  DiGithub,
  DiBootstrap,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
  SiTailwindcss,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />{" "}
        <div className="purple" style={{ fontSize: 15 }}>
          JavaScript
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNpm />
        <div className="purple" style={{ fontSize: 15 }}>
          NPM
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <div className="purple" style={{ fontSize: 15 }}>
          NodeJS
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <div className="purple" style={{ fontSize: 15 }}>
          ReactJS
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiBootstrap />
        <div className="purple" style={{ fontSize: 15 }}>
          BootStrap
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGithub />
        <div className="purple" style={{ fontSize: 15 }}>
          GitHub
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss />
        <div className="purple" style={{ fontSize: 15 }}>
          TailwindCSS
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
        <div className="purple" style={{ fontSize: 15 }}>
          FireBase
        </div>
      </Col>
    </Row>
  );
}

export default Techstack;
